[
  {
    "id": 1,
    "title": "GPT LLM Playground",
    "role": "Creator",
    "excerpt": "Engineered a GPT-1 style transformer with modular data preprocessing, training, and inference pipelines.",
    "body": "Engineered a GPT-1 style transformer from scratch to understand the inner workings of LLMs. Implemented modular data preprocessing, custom training loops, and optimized inference pipelines.",
    "thumbnail": "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=500&h=320&q=80",
    "gallery": [
      "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=1200&h=600&q=80"
    ],
    "technologies": [
      "Python",
      "TensorFlow",
      "NLP"
    ],
    "links": {
      "github": "https://github.com/HelloVishnu04/GPT-LLM-Playground"
    }
  },
  {
    "id": 2,
    "title": "S.A.F.E. – Real-Time AI Pipeline",
    "role": "Creator",
    "excerpt": "Built a real-time ingestion-to-inference pipeline with automated training, model versioning, and scalable REST API deployment.",
    "body": "Built a scalable real-time AI pipeline for end-to-end machine learning. This included data ingestion, automated model training and versioning, and deploying models as scalable REST APIs for real-time inference.",
    "thumbnail": "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=500&h=320&q=80",
    "gallery": [
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&h=600&q=80"
    ],
    "technologies": [
      "Python",
      "TensorFlow",
      "REST API"
    ],
    "links": {
      "github": "https://github.com/HelloVishnu04"
    }
  }
]